/**
 * Convert a data structure to an array (e.g. a node list such as node.childNodes)
 */
export default (list: HTMLCollection | NodeListOf<Element> | HTMLElement[]): HTMLElement[] => {
  return Array.prototype.slice.call(list);
};
